import { NgModule } from '@angular/core';
import { SharedModule } from '../../../shared';
import { UsuarioPipesModule } from '../pipes';
import { UsuarioSelectComponent } from './usuario-select.component';


@NgModule({
    imports: [
        SharedModule,
        UsuarioPipesModule
    ],
    declarations: [
        UsuarioSelectComponent
    ],
    exports: [
        UsuarioSelectComponent
    ]
})
export class UsuarioSelectModule { }
